module.exports = __webpack_public_path__ + "img/ve.2d0527c8.svg";